module.exports = __webpack_public_path__ + "static/media/bursts_22.59afd6bd.svg";